import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/book-call/BookCallClient.tsx");
